import { EMAIL_REGEX } from '@utils/html-sanitizer.util';
import { FazerPedidoService } from '@services/fazer-pedido.service';
import { BaseFormService } from '@services/base-form.service';
import { take } from 'rxjs/operators';
import moment from 'moment';

export abstract class PedidoFormBase extends BaseFormService {

  public contatos: any;
  public contatoSelecionado: any = '';
  public dataPagamento: any;
  public dataInicialPedido: any;
  public dataFinalPedido: any;
  public ordemEnvelopes: any = 'N';
  public emailConfirmacao: any;
  public emailNfe1: any;
  public emailNfe2: any;
  public prePago: boolean;

  public contatoSelecionadoError = false;
  public dataInicialError = false;
  public dataInicialMessageError = 'Data Inicial Inválida';
  public dataFinalError = false;
  public dataFinalMessageError = 'Data Final Inválida';
  public dataPagamentoError = false;
  public dataPagamentoMessageError = 'Data de Pagamento Inválida';
  public departamentoError = false;
  public emailValidacaoError = false;
  public emailNfe1Error = false;
  public emailNfe2Error = false;
  public isErrorFields = false;
  public showAlertConfirmaPedido = false;

  protected dataAtual: string;

  constructor(protected readonly fazerPedidoService: FazerPedidoService) {
    super();
    const data = new Date();
    this.dataAtual = `${data.getFullYear()}-${data.getMonth() + 1}-${data.getDate()}`;
  }

  onContatoSelecionado() {
    this.contatoSelecionadoError = this.contatoSelecionado.length === 0;
    this.getEmailContato();
  }

  getEmailContato() {
    if (this.contatoSelecionado !== 0) {
      this.fazerPedidoService.getDadosContato(this.contatoSelecionado)
        .pipe(take(1)).subscribe({
          next: (resposta: any) => {
            this.emailConfirmacao = resposta.response.emailContato;
            this.onEmailConfirmacao();
          },
          error: () => { this.emailConfirmacao = ''; }
        });
    }
    if (this.contatoSelecionado === 0) {
      this.emailConfirmacao = '';
    }
  }

  onDataPagamento() {
    if (moment(this.dataPagamento).add(1, 'day') < moment()) {
      this.dataPagamentoMessageError = 'Data deve ser maior ou igual a data atual';
      this.dataPagamentoError = true;
    } else if (moment(this.dataPagamento) >= moment().add(30, 'days')) {
      this.dataPagamentoMessageError = 'Data de Pagamento deve acontecer antes de 30 dias';
      this.dataPagamentoError = true;
    } else {
      this.dataPagamentoError = false;
      this.dataPagamentoMessageError = 'Data de Pagamento Inválida';
    }
  }

  onDataInicialPedido() {
    if (!this.dataInicialPedido) {
      this.dataInicialError = true;
      this.dataInicialMessageError = 'Data Inicial Inválida';
      return;
    }
    if (this.dataFinalPedido && moment(this.dataInicialPedido) > moment(this.dataFinalPedido)) {
      this.dataInicialError = true;
      this.dataInicialMessageError = 'Data Inicial maior que Data Final';
    } else {
      this.dataInicialError = false;
      this.dataInicialMessageError = 'Data Inicial Inválida';
    }
  }

  onDataFinalPedido() {
    if (!this.dataFinalPedido) {
      this.dataFinalError = true;
      this.dataFinalMessageError = 'Data Final Inválida';
      return;
    }
    if (this.dataInicialPedido && moment(this.dataInicialPedido) > moment(this.dataFinalPedido)) {
      this.dataFinalError = true;
      this.dataFinalMessageError = 'Data Final menor que Data Inicial';
    } else {
      this.dataFinalError = false;
      this.dataFinalMessageError = 'Data Final Inválida';
    }
  }

  onEmailConfirmacao() {
    this.emailValidacaoError = this.emailConfirmacao ? !EMAIL_REGEX.test(this.emailConfirmacao) : false;
  }

  onEmailNfe1() {
    this.emailNfe1Error = this.emailNfe1 ? !EMAIL_REGEX.test(this.emailNfe1) : false;
  }

  onEmailNfe2() {
    this.emailNfe2Error = this.emailNfe2 ? !EMAIL_REGEX.test(this.emailNfe2) : false;
  }

  onConcluirPedido() {
    this.showAlertConfirmaPedido = true;
    this.fazerPedidoService.messageDataServicePedido.next(this.showAlertConfirmaPedido);
  }

  protected validarContato(form: any): void {
    if (this.contatoSelecionado) {
      form.contato = this.contatoSelecionado;
    } else {
      this.contatoSelecionadoError = true;
      this.isErrorFields = true;
    }
  }

  protected validarDataPagamento(form: any): void {
    if (!this.prePago) {
      form.dtPgto = '';
      return;
    }
    if (this.dataPagamento && !this.dataPagamentoError) {
      form.dtPgto = this.dataPagamento.toISOString();
    } else {
      this.dataPagamentoError = true;
      this.isErrorFields = true;
    }
  }

  protected validarDataInicial(form: any): void {
    if (this.dataInicialPedido && !this.dataInicialError) {
      form.dtIni = this.dataInicialPedido.toISOString();
    } else {
      this.dataInicialError = true;
      this.isErrorFields = true;
    }
  }

  protected validarDataFinal(form: any): void {
    if (this.dataFinalPedido && !this.dataFinalError) {
      form.dtFim = this.dataFinalPedido.toISOString();
    } else {
      this.dataFinalError = true;
      this.isErrorFields = true;
    }
  }

  protected validarEnvelopes(form: any): void {
    if (this.ordemEnvelopes) {
      form.envelopes = this.ordemEnvelopes;
    } else {
      this.departamentoError = true;
      this.isErrorFields = true;
    }
  }

  protected validarEmails(form: any): void {
    if (this.emailConfirmacao) {
      form.emailConf = this.emailConfirmacao;
    } else {
      this.emailValidacaoError = true;
      this.isErrorFields = true;
    }
    if (this.emailNfe1) {
      form.emailNfe1 = this.emailNfe1;
    } else {
      this.emailNfe1Error = true;
      this.isErrorFields = true;
    }
    if (this.emailNfe2) {
      form.emailNfe2 = this.emailNfe2;
    } else {
      this.emailNfe2Error = true;
      this.isErrorFields = true;
    }
  }
}
